export const FACEBOOK_APP_ID = "278597534673550";
export const GOOGLE_CLIENT_ID = "7047758356-2bcl5irdliegi98eelgjsm0ur9b0i9ru.apps.googleusercontent.com";
export const DISCORD_CLIENT_ID = "1121115280274378783";
// e.g., https://client-api.akedo.gg/discord-callback , https://react.akedo.gg/discord/callback // encodeURIComponent("http://localhost:3000/discord-callback")
export const DISCORD_OAUTH_URL = `https://discord.com/oauth2/authorize?client_id=${DISCORD_CLIENT_ID}&redirect_uri=DISCORD_REDIRECT_URI&response_type=token&scope=identify+email`;
